import { addTouchEvent } from "./events";
import store from "./store";
import { getLogger } from "./logging";
import { IS_CHROMIUM, IS_SAFARI } from "./config";

const unsupportedBrowsserDialogEl = document.getElementById(
  "unsupported-browser-dialog"
);
const unsupportedBrowsserDialogBtnEl = document.getElementById(
  "unsupported-browser-dialog-ok"
);

const log = getLogger("Unsupported Browser");

function close() {
  store.set("unsupportedBrowserDialogShown", true);
  unsupportedBrowsserDialogEl.style.display = null;
}

function show() {
  unsupportedBrowsserDialogEl.style.display = "block";
}

addTouchEvent(unsupportedBrowsserDialogBtnEl, close);

function showIfUnsupported() {
  if (IS_SAFARI || IS_CHROMIUM) return;
  log.warn("Unsupported browser");
  if (!store.unsupportedBrowserDialogShown) show();
}

showIfUnsupported();
